import { useTranslation } from 'react-i18next'

import { GRETA_FEEDBACK_REASONS } from '../GretaAIChatFeedbackForm.constants'
import { GretaAIChatFeedbackReason } from '../GretaAIChatFeedbackReason'

import * as styles from './GretaAIChatFeedbackReasonField.module.css'

function GretaAIChatFeedbackReasonField({ reason, onChangeReason }) {
  const { t } = useTranslation()

  return (
    <div className={styles.field}>
      <div className={styles.label}>{t('Greta.FeedbackReasonLabelKey')}</div>

      <div className={styles.reasons}>
        {GRETA_FEEDBACK_REASONS.map(item => (
          <GretaAIChatFeedbackReason
            isSelected={reason === item.id}
            key={item.id}
            reason={item}
            onSelect={onChangeReason}
          />
        ))}
      </div>
    </div>
  )
}

export default GretaAIChatFeedbackReasonField
